import { Extension } from '@tiptap/core';
import Suggestion from '@tiptap/suggestion';

export interface VariableOption {
    id: string;
    name: string;
}

export interface VariableExtensionOptions {
    getVariables: () => VariableOption[];
}

export const VariableExtension = Extension.create<VariableExtensionOptions>({

    name: 'variable',

    addOptions() {
        return {
            getVariables: () => []
        };
    },

    addProseMirrorPlugins() {

        const getVariables = this.options.getVariables;

        return [
            Suggestion({

                editor: this.editor, // ✔ NECESSARIO in questa versione

                char: '{',

                startOfLine: false,

                allowSpaces: false,

                items: ({ query }: { query: string }) => {

                    const q = query.toLowerCase();

                    return getVariables().filter(v =>
                        v.name.toLowerCase().includes(q) || v.id.toLowerCase().includes(q)
                    );
                },

                command: ({ editor, range, props }: any) => {

                    editor
                        .chain()
                        .focus()
                        .insertContentAt(range, `{{${props.id}}}`)
                        .run();
                },

                render: () => {

                    let popup: HTMLElement;
                    let selectedIndex = 0;
                    // onKeyDown non riceve items/command: li teniamo dall'ultimo onStart/onUpdate
                    let currentProps: any;

                    const update = (props: any) => {

                        currentProps = props;

                        if (!popup) return;

                        popup.innerHTML = '';

                        props.items.forEach((item: VariableOption, index: number) => {

                            const el = document.createElement('div');

                            el.className = 'variable-item';

                            if (index === selectedIndex) {
                                el.classList.add('active');
                            }

                            el.innerText = item.name;
                            el.title = item.id;

                            el.onmousedown = (event: MouseEvent) => {
                                event.preventDefault();
                                props.command(item);
                            };

                            popup.appendChild(el);
                        });
                    };

                    return {

                        onStart: (props: any) => {

                            selectedIndex = 0;

                            popup = document.createElement('div');
                            popup.className = 'variable-popup';

                            document.body.appendChild(popup);

                            const rect = props.clientRect?.();

                            if (rect) {
                                popup.style.position = 'absolute';
                                popup.style.top = `${rect.bottom + window.scrollY}px`;
                                popup.style.left = `${rect.left + window.scrollX}px`;
                            }

                            update(props);
                        },

                        onUpdate(props: any) {

                            selectedIndex = 0;

                            const rect = props.clientRect?.();

                            if (rect) {
                                popup.style.top = `${rect.bottom + window.scrollY}px`;
                                popup.style.left = `${rect.left + window.scrollX}px`;
                            }

                            update(props);
                        },

                        onKeyDown(props: any) {

                            const items: VariableOption[] = currentProps?.items ?? [];

                            if (!items.length) return false;

                            if (props.event.key === 'Escape') {
                                popup?.remove();
                                return true;
                            }

                            if (props.event.key === 'ArrowDown') {
                                selectedIndex = (selectedIndex + 1) % items.length;
                                update(currentProps);
                                return true;
                            }

                            if (props.event.key === 'ArrowUp') {
                                selectedIndex =
                                    (selectedIndex - 1 + items.length) % items.length;
                                update(currentProps);
                                return true;
                            }

                            if (props.event.key === 'Enter' || props.event.key === 'Tab') {

                                const item = items[selectedIndex];

                                if (!item) return true;

                                currentProps.command(item);

                                popup?.remove();

                                return true;
                            }
                            return false;
                        },

                        onExit() {
                            popup?.remove();
                        }

                    };
                }

            })
        ];
    }

});